import { useContext } from 'react'
import { Button } from '../Styles'
import { useLocation, useNavigate } from 'react-router-dom'
import { ModalEstadoContext } from '../../contexts/ModalEstado'
import { AuthContext } from "../../contexts/Auth"
import { propsProjetosUsuario } from '../../interfaces/auth'
import { AuthGoogle } from '../../helpers/auth'
import { criptografarDado } from '../../helpers'
import { projetosUsuario } from '../../interfaces/auth'
import organizacaoDefault from '../../assets/img/organizacao.png'
import './modalProjetos.css'
import { recuperarSenha } from '../../services/auth'

function ModalProjetosUsuario({ dados }: propsProjetosUsuario) {

    const { modalExibir } = useContext(ModalEstadoContext)
    const { isAuth } = useContext(AuthContext)

    const navigate = useNavigate()
    const location = useLocation()
    const { pathname } = location

    const [tokens, email] = location.hash.substring(1).split('#');
    const [emailUsuario] = location.hash.substring(1).split('#')

    const ocultarModal = () => {
        modalExibir('')
        return navigate('/')
    }

    const selecionarProjeto = async (projeto: projetosUsuario) => {
        if (emailUsuario) {

            const payload = {
                email: emailUsuario,
                idOrganizacao: projeto.idOrganizacao
            }

            await recuperarSenha(payload)

            navigate(`${pathname}?o-s=${projeto.idOrganizacao}`)

            return modalExibir('')
        }

        const idProjetoCript = criptografarDado(projeto.id.toString())

        modalExibir('')

        if (tokens && email) {
            AuthGoogle({
                idOrganizacao: projeto.idOrganizacao,
                tokens,
                email,
                isAuth,
                idProjeto: projeto.id,
                grupo: projeto.grupo,
                navigate
            })

            const rota = projeto.grupo === 'Desenvolvimento de Software' ? '/kanban' : '/desafios'
            return navigate(`${rota}?grupo=${projeto.grupo}&idProjeto=${idProjetoCript}&o-s=${projeto.idOrganizacao}`)
        }

        navigate(`${pathname}?grupo=${projeto.grupo}&idProjeto=${idProjetoCript}&o-s=${projeto.idOrganizacao}`)
        return modalExibir('')
    }

    return (
        <div className='modalUsuarioProjeto'>
            <section className='modalUsuarioProjetoContainer'>
                <span className='modalUsuarioProjetoContent'>
                    {dados.map((dado) => (
                        <div key={dado.id} onClick={() => selecionarProjeto(dado)}>
                            <img src={dado.cadastro.avatar || organizacaoDefault} alt='' />
                            <span>
                                <strong><p>{dado.titulo}</p></strong>
                                <p>{dado.grupo}</p>
                            </span>
                        </div>
                    ))}
                </span>
                <Button type='button' cor='cancelar' isLoading={false} onClick={ocultarModal}>Cancelar Operação</Button>
            </section>
        </div>
    )
}

export default ModalProjetosUsuario
